import HubspotEmbeddedForm from "./HubspotEmbeddedForm";

export default HubspotEmbeddedForm;